<template>
  <div class="baogao-detail">
    <div class="baogao-detail-top">
      <img src="~@/assets/images/zhuyuan/zy-jy-bj.png" alt="">
    </div>
    <!-- <table class="table">
      <tr class="bor">
        <th></th>
        <th>检验项目</th>
        <th>结果</th>
        <th>参考值</th>
        <th>单位</th>
      </tr>
      <tr v-for="item in list" :key="item.id">
        <td>{{item.itemCode}}</td>
        <td>{{item.itemName}}</td>
        <td>{{item.currentResult}}</td>
        <td>{{item.ranges}}</td>
        <td>{{item.unit}}</td>
      </tr>
    </table> -->
    <van-cell-group class="centre" inset>
      <van-cell title="开方医生">
        <template #default>
          {{ info.sourceDoctor }}
        </template>
      </van-cell>
      <van-cell title="开方科室">
        <template #default>
          {{ info.department }}
        </template>
      </van-cell>
      <van-cell title="报告时间">
        <template #default>
          {{ info.reportDate }}
        </template>
      </van-cell>
      <van-cell title="报告单号">
        <template #default>
          {{ info.allBarCodes }}
        </template>
      </van-cell>
    </van-cell-group>
    <div class="list-box">
      <div class="list-wrap">
        <div class="list-item" />
        <div class="list-item">检验项目</div>
        <div class="list-item">结果</div>
        <div class="list-item">参考值</div>
        <div class="list-item">单位</div>
      </div>
      <div v-for="item in list" :key="item.id" class="list-wrap list-wrap2">
        <div class="list-item">{{ item.itemCode }}</div>
        <div class="list-item">{{ item.itemName }}</div>
        <div class="list-item">{{ item.currentResult }}</div>
        <div class="list-item">{{ item.ranges }}</div>
        <div class="list-item">{{ item.unit }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaoGaoDetail',
  data() {
    return {
      info: {},
      list: [],
      patientName: '',
      reportNo: ''
    }
  },
  created() {
    this.patientName = this.$route.query.patientName
    this.reportNo = this.$route.query.reportNo
    const baogaoDetail = localStorage.getItem('baogaoDetail')
    this.getReportDetail()
    if (!baogaoDetail) return
    this.info = JSON.parse(baogaoDetail)
  },
  mounted() {},
  methods: {
    getReportDetail() {
      this.$Apis.getReportDetail({ patientName: this.patientName, reportNo: this.reportNo }).then(res => {
        this.list = res.data.tables
      })
    }
  }
}
</script>
<style rel="stylesheet/less" lang="less" scoped>
.baogao-detail{
  overflow: hidden;
  min-height: 100vh;
  .baogao-detail-top{
    padding: .1rem .15rem 0;
    min-height: 1.25rem;
    img {
      display: block;
      width: 100%;
      height: auto;
    }
  }
  .centre{
    margin: .1rem .15rem;
  }
  .list-box{
    margin: .1rem .15rem;
    padding: .1rem;
    background: #fff;
    border-radius: .1rem;
  }
  .list-wrap{
    display: flex;
    border-top: 1px solid #E8EAED;
    border-bottom: 1px solid #E8EAED;
    .list-item{
      color: #2B8CFF;
      background: #F8F8F8;
      flex: 1;
      word-break: break-all;
      // white-space:nowrap;
      padding: .1rem .05rem;
      display: flex;
      align-items: center;
      justify-content: center;
      line-height: 1.5;
      border-left: 1px solid #E8EAED;
    }
    :last-child{
      border-right: 1px solid #E8EAED;
    }
  }
  .list-wrap2{
    border-top: none;
    .list-item{
      color: #555;
      background: #fff;
    }
  }
  .table{
    padding: 0 .15rem;
    background: #fff;
    width: 100%;
    tr{
      border-bottom: 1px solid #ccc;
    }
    th{
      line-height: .3rem;
      font-size: .14rem;
    }
    td{
      line-height: .3rem;
      font-size: .12rem;
    }
  }
}
</style>
